
	/**
	 * @description
	 *  Ítems de reemplazo asociados a una nota de CyR o NC, sobre un pedido.
	 *
	 * @see gigot-backend/Models/Orders/OrderEvent.cs
	 */

export class ReplacementItem {

	public campaignProductReplacementId: number;
	public id: number;
	public orderEventId: number;
	public quantity: number;

	/**
	 * @description
	 *	Construye un ítem de reemplazo con una semántica vacía. Nótese que no
	 *	es lo mismo que construir un ítem con valores por defecto. Las reglas
	 *	generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un ítem de reemplazo vacío.
	 */
	public static empty(): ReplacementItem {
		const replacementItem: ReplacementItem = new ReplacementItem();
		replacementItem.campaignProductReplacementId = undefined;
		replacementItem.id = undefined;
		replacementItem.orderEventId = undefined;
		replacementItem.quantity = undefined;
		return replacementItem;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicReplacementItem
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicReplacementItem: ReplacementItem): ReplacementItem {
		if (!anemicReplacementItem) return undefined;
		const replacementItem: ReplacementItem = ReplacementItem.empty();
		replacementItem.campaignProductReplacementId = anemicReplacementItem.campaignProductReplacementId;
		replacementItem.id = anemicReplacementItem.id;
		replacementItem.orderEventId = anemicReplacementItem.orderEventId;
		replacementItem.quantity = anemicReplacementItem.quantity;
		return replacementItem;
	}
}
